export enum EntryType {
    AlphaNumeric = 0,
    Numeric,
  }
  